import React from "react";

const StyledXsText = ({ children, fontColor }) => {
  return <p className={`text-xs font-inter ${fontColor}`}>{children}</p>;
};

export default StyledXsText;
